import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { isAdmin, isSuperAdmin } from '../models/user.model';
import { SpaceContextService } from '../services/space-context.service';

function getSlug(route: ActivatedRouteSnapshot): string {
  let r: ActivatedRouteSnapshot | null = route;
  while (r) {
    const slug = r.paramMap.get('slug');
    if (slug) return slug;
    r = r.parent;
  }
  return '';
}

export const authGuard: CanActivateFn = (route) => {
  const auth   = inject(AuthService);
  const router = inject(Router);
  if (!auth.isAuthenticated()) {
    const slug = getSlug(route);
    return router.createUrlTree([slug ? `/${slug}/login` : '/']);
  }
  const u = auth.getCurrentUser();
  if (u?.membershipStatus === 'PENDING') {
    const slug = getSlug(route);
    return router.createUrlTree([`/${slug}/pending`]);
  }
  return true;
};

export const adminGuard: CanActivateFn = (route) => {
  const auth     = inject(AuthService);
  const router   = inject(Router);
  const spaceSvc = inject(SpaceContextService);
  if (!auth.isAuthenticated()) {
    const slug = getSlug(route);
    return router.createUrlTree([slug ? `/${slug}/login` : '/']);
  }
  const u = auth.getCurrentUser();
  if (isSuperAdmin(u) || isAdmin(u)) return true;
  // Usuario con spaceRole MEMBER pero membresía ADMIN en el espacio actual
  const currentSpaceId = spaceSvc.spaceId;
  const isAdminOfSpace = (u?.memberships ?? []).some(
    m => m.spaceId === currentSpaceId && (m.role === 'ADMIN' || m.role === 'STAFF')
  );
  if (isAdminOfSpace) return true;
  const slug = getSlug(route);
  return router.createUrlTree([`/${slug}/home`]);
};

export const superAdminGuard: CanActivateFn = () => {
  const auth   = inject(AuthService);
  const router = inject(Router);
  if (!auth.isAuthenticated()) return router.createUrlTree(['/super-admin/login']);
  const u = auth.getCurrentUser();
  if (isSuperAdmin(u)) return true;
  return router.createUrlTree(['/']);
};
